export default function About() {
	return (
		<section id="about">
			<div className="fn_cs_about">
				<div className="left_part lp">
					<div className="img">
						<div className="img_in" data-bg-img="assets/NFTON.IO.png"><img src="img/1x1.jpg" alt="" /></div>
					</div>
					<div className="bg_overlay bo">
						<div className="bg_color"></div>
						<div className="bg_image" data-bg-img="nfts/5.png"></div>
					</div>
				</div>
				<div className="right_part">
					<div className="right_in">
						<h3 className="fn__maintitle" data-text="ABOUT US">ABOUT US</h3>
						<div className="fn_cs_divider">
							<div className="divider">
								<span></span>
								<span></span>
							</div>
						</div>
						<div className="desc">
							<p>Our objective is to promote innovation in the NFT market. In some genuine ways:</p>
							<p>-All creators will be able to get their own collections, minting websites, and smart contracts in reasonable rates.</p>
							<p>-Without learning new skills or spending thousands of dollars, this will be possible. Web3 will be open to everyone.</p>
							<p>-From the start, our nft holders will be consider whitelisted for all of the future premium NFTs and tools.</p>
							<p>-Upcoming tools &amp; services will be listed on the site soon...</p>
						</div>
						<a href="https://twitter.com/NFTON_IO/" className="metaportal_fn_button" target="_blank"><span>Find us On Twitter</span></a>
					</div>
				</div>
			</div>
		</section>
	)
}